import { render, staticRenderFns } from "./AutoInvestStrategyForm.vue?vue&type=template&id=3b7bc310&"
import script from "./AutoInvestStrategyForm.vue?vue&type=script&lang=js&"
export * from "./AutoInvestStrategyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports